export const KIKI = {
  brand: "Kiki Centre for Technology",
  tagline: "We make the people who will make in India",
  phone: "+91 8800288994",
  phoneRaw: "+918800288994",
  whatsapp: "918800288994",
  email: "info@kikicentre.com",
  address: "1/47, Sector 75A, Gurugram, Delhi-NCR, India",
  partner: "German Chamber of Skilled Crafts (HWK), Koblenz, Germany",
};

export const COURSES = [
  {
    id: "tool-die",
    stream: "Mechanical",
    title: "Tool & Die Making",
    subtitle: "Mechanical Manufacturing & Designing with Entrepreneurship",
    duration: "3.5 Years",
    eligibility: "Class 10 / Class 12 Pass",
    certification: "German Chamber of Skilled Crafts, Koblenz",
    highlights: [
      "Industrial work-study training from Year 2",
      "Earn while you learn — stipend by partner companies",
      "Indian & International Certificate",
      "World-class practical training & exposure",
    ],
    image:
      "https://customer-assets.emergentagent.com/job_join-kiki/artifacts/j6mg1r7g_079%20%281%29.jpg",
  },
  {
    id: "precision-machining",
    stream: "Mechanical",
    title: "Precision Machining Technology",
    subtitle: "CNC, VMC, 5-axis, CAD/CAM",
    duration: "3.5 Years",
    eligibility: "Class 10 / Class 12 Pass",
    certification: "German Chamber of Skilled Crafts, Koblenz",
    highlights: [
      "Master CNC programming & operations",
      "Live industry projects from Year 2",
      "Stipend during on-job training",
      "Direct placement support",
    ],
    image:
      "https://customer-assets.emergentagent.com/job_join-kiki/artifacts/q0kg32kb_2016_Feb_kiki_058.jpg",
  },
  {
    id: "mechatronics",
    stream: "Electrical & Electronics",
    title: "Mechatronics",
    subtitle: "Automation & Robotics with IoT, Industry 4.0 & AI",
    duration: "3.5 Years",
    eligibility: "Class 10 / Class 12 Pass",
    certification: "German Chamber of Skilled Crafts, Koblenz",
    highlights: [
      "PLC, robotics & Industry 4.0",
      "Hands-on with Mitsubishi systems",
      "Earn while you learn — Year 2 onwards",
      "High-demand industry skill set",
    ],
    image:
      "https://customer-assets.emergentagent.com/job_join-kiki/artifacts/1f83rvoq_IMG_20160717_141358.jpg",
  },
];

export const PARTNERS = [
  "Maruti Suzuki",
  "Honda",
  "Mitsubishi Electric",
  "Subros",
  "IFB",
  "Bridgestone",
  "Stryker",
  "Asahi Glass",
  "Denso",
  "Faurecia",
  "PPAP",
  "Daifuku",
  "Dantal",
  "Nifco",
  "Becton Dickenson",
];

export const STATS = [
  { value: "25,000", suffix: "sq ft", label: "Training Campus" },
  { value: "3.5", suffix: "years", label: "Diploma Duration" },
  { value: "India", suffix: "& Abroad", label: "Placement Reach" },
  { value: "70%", suffix: "", label: "Hands-on Practical" },
];

export const TESTIMONIALS = [
  {
    name: "Rohit S.",
    course: "Mechatronics, 2023 Batch",
    quote:
      "I was doing diploma elsewhere, but there were no practicals. Here every student matters — German-level training in India.",
  },
  {
    name: "Aman K.",
    course: "Tool & Die Making",
    quote:
      "From the second year I started earning a stipend while learning at a partner company. Best decision after Class 12.",
  },
  {
    name: "Pooja V.",
    course: "Precision Machining",
    quote:
      "The instructors are trained by German experts. I got placed before completing the course.",
  },
];

export const FAQS = [
  {
    q: "What are the placement stats?",
    a: "We have mostly 100% placement record in India & abroad for students who pass the course and attend all interviews.",
  },
  {
    q: "Who can apply for the 3.5-year courses?",
    a: "Any student who has passed Class 10 or Class 12 (any stream) can apply. Selection is based on a simple aptitude check and interview.",
  },
  {
    q: "What is 'Earn While You Learn'?",
    a: "From the second year onwards, students undergo industrial training with our partner companies and receive a monthly stipend / training allowance.",
  },
  {
    q: "Is the certification valid abroad?",
    a: "Yes. Long-term courses are certified by the German Chamber of Skilled Crafts (HWK), Koblenz, Germany as well as Indian Skill Certificate. Several of our students are working abroad through campus placement after the course.",
  },
  {
    q: "Where is the campus located?",
    a: "Our 25,000 sq ft training centre is at 1/47, Sector 75A, Gurugram (Delhi-NCR region).",
  },
  {
    q: "Are scholarships available?",
    a: "Yes — financial aid and scholarships are available for eligible students. Our counsellors will guide you through the process when you apply.",
  },
  {
    q: "How do I apply?",
    a: "Just fill the admission form on this page, call +91 8800288994, or message us on WhatsApp. Our counsellor will contact you within 24 hours.",
  },
];
